export const confirmReallocateMessage = {
  title: 'Need confirmation',
  message: 'Some of the selected employees are already assigned to other roles. Do you want to continue?'
};
